import classNames from "classnames";
import { FC, useRef } from "react";
import { Link } from "react-router-dom";
import { msalApp } from "../context/authContext";
import useIdentity from "../hooks/useIdentity";
import useOnClickOutside from "../hooks/useOnclickOutside";
import useToggle from "../hooks/useToggle";
import { useI18n } from "../hooks/useTranslations";
import styles from "./AccountButton.module.css";
import SvgLogout from "./icons/Logout";
import Icon from "./ui/Icon";
import UserInitials from "./UserInitials";

const AccountButton: FC = () => {
  const i18n = useI18n();
  const { close, isOpen, open } = useToggle();
  const logout = async () => {
    await msalApp.logoutRedirect({
      postLogoutRedirectUri: window.location.href,
    });
  };
  const identity = useIdentity();

  const menuRef = useRef<HTMLDivElement>(null);

  useOnClickOutside(menuRef, () => isOpen && close());

  const fullName = `${identity?.lastName ?? ""} ${identity?.firstName ?? ""}`.trim();

  const userInitials = (
    <UserInitials firstName={identity.firstName ?? ""} lastName={identity.lastName ?? ""} userId={identity.id} />
  );

  return (
    <>
      <div className={classNames(styles.avatar, isOpen ? styles.open : undefined)} onClick={isOpen ? close : open}>
        {userInitials}
      </div>
      <div className={classNames(styles.account, isOpen ? styles.visible : undefined)} ref={menuRef}>
        <div className={styles["user-info"]}>
          {userInitials}
          <div>
            <div className={styles.name}>{fullName}</div>
            <Link to={`mailto:${identity.email}`}>{identity.email}</Link>
          </div>
        </div>
        <div>
          <button
            className={styles.logout}
            onClick={() => {
              logout();
              close();
            }}
          >
            <Icon glyph={SvgLogout} className={styles.icon} />
            {i18n.t.common.logout}
          </button>
        </div>
      </div>
    </>
  );
};

export default AccountButton;
